<ng-container *ngIf="!isLoading">
   
    <div>
        <div class="container" id="print-section1">
            <table class="table table-bordered">
                <thead>
                     <tr >
                        <th [attr.colspan]="totalth - 7" class="largeHeading" style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">दि. {{ endDate | date:"dd/MM/yyyy" }} च्या अंकाकरिता</th>
                    </tr>
                    <tr>
                        <th style="border-left: 2px solid black; border-bottom: 2px solid black; color: black;">अनु क्र.</th>
                        <th style="border-left: 2px solid black; border-bottom: 2px solid black; border-right: 2px solid black; color: black;">जिल्हा</th>
                        <ng-container *ngFor="let item of subTypesName">
                            <th *ngIf="item['isVisible']" style="border-bottom: 2px solid black; color: black;">{{ item['name'] }}</th>
                        </ng-container>
                        <!-- <th colspan="2">सप्रेम भेट</th> -->
                        <th style="border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">एकूण सप्रेम<br />भेट</th>
                        <th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">एकूण वर्गणीदार</th>
                        <th style="border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">सप्रेमभेट + वर्गणीदार एकूण</th>
                        <!-- <th style="border-right: 2px solid black;"></th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of districtwiseData; let i=index">
                        <td style="font-weight: bold; border-left: 2px solid black; border-right: 2px solid black; color: black;">{{ i+1 }}</td>
                        <td style="font-weight: bold; border-right: 2px solid black; color: black;" class="district-col">{{ item['districtName'] }}</td>
                        <ng-container *ngFor="let data of subTypesName">
                            <td *ngIf="data['isVisible']" style="text-align: right; color: black;">{{ item[getKey(data['name'])] }}</td>
                        </ng-container>
                        <!-- <td style="text-align: right;">{{ item['सप्रेम_भेट_1'] }}</td> -->
                        <!-- <td style="text-align: right;">{{ item['सप्रेम_भेट_2'] }}</td> -->
                        <td style="text-align: right; border-left: 2px solid black; color: black;">{{ item['एकूणसप्रेम_भेट'] }}</td>
                        <td style="text-align: right; color: black;">{{ item['एकूण'] }}</td>
                        <td style="text-align: right; border-right: 2px solid black; color: black;">{{ item['सप्रेम_एकूण'] }}</td>
                        <!-- <td style="border-right: 2px solid black; color: black;" class="district-col">{{ item['districtName'] }}</td> -->
                    </tr>
                    <tr>
                        <!-- <td></td> -->
                        <td colspan="2" style="font-weight: bold; text-align: center; border-left: 2px solid black; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">एकूण</td>
                        <ng-container *ngFor="let data of subTypesName">
                            <td *ngIf="data['isVisible']" style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">{{ districtwiseDataTotal[getKey(data['name'])] }}</td>
                        </ng-container>
                        <!-- <td style="font-weight: bold; text-align: right;">{{ districtwiseDataTotal['सप्रेम_भेट_1'] }}</td> -->
                        <!-- <td style="font-weight: bold; text-align: right;">{{ districtwiseDataTotal['सप्रेम_भेट_2'] }}</td> -->
                        <td style="font-weight: bold; text-align: right; border-left: 2px solid black;  border-top: 2px solid black; border-bottom: 2px solid black; color: black;">{{ districtwiseDataTotal['एकूणसप्रेम_भेट'] }}</td>
                        <td style="font-weight: bold; text-align: right; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">{{ districtwiseDataTotal['एकूण'] }}</td>
                        <td style="font-weight: bold; text-align: right; border-right: 2px solid black; border-top: 2px solid black; border-bottom: 2px solid black; color: black;">{{ districtwiseDataTotal['सप्रेम_एकूण'] }}</td>
                        <!-- <td style="border-right: 2px solid black; border-bottom: 2px solid black;"></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</ng-container>
<div *ngIf="isLoading" class="main-loading">
    <span class="loader"></span>
    <p>Loading...</p>
</div>

 <div>
        <!-- [useExistingCss]="true" -->
        <div style="margin-left: 43%; margin-top: 0%; margin-bottom: 2%">
            <!-- <button
                [printStyle]="{table : {'border-collapse':'collapse'}, td : {'border': 'solid 1px', 'font-size':'14px', 'font-weight':'600', 'text-align':'center'}, th : {'border': 'solid 1px', 'font-size':'16px', 'font-weight':'600', 'text-align':'center'}, div : {'font-size':'14px', 'font-weight':'600'}}"
                class="noPrint" style="margin-right: 2%; margin-left: 2%" mat-raised-button color="primary"
                printSectionId="print-section" ngxPrint>
                Print
            </button> -->

            <button class="noPrint"
        style="margin-top: 2%; margin-left: 43%; margin-bottom: 2%"
        mat-raised-button color="primary"
        (click)="printPage()">
         Print
       </button>
            <button class="noPrint" style="margin-top: 2% 2% 0 2%; margin-left: 2%"
                (click)="exportExcel('Districtwise_Subscription_Report')" mat-raised-button color="primary">
                Export
            </button>
            <button mat-dialog-close class="btn noPrint">
                Close
            </button>
        </div>
    </div>